import { CONTACT, SOCIAL } from "../data/content";

const DESTINATIONS = [
  "Indore",
  "Bhopal",
  "Ujjain",
  "Maheshwar",
  "Pachmarhi",
  "Omkareshwar",
];
const LINKS = [
  ["About Us", "#about"],
  ["Our Fleet", "#fleet"],
  ["Tour Packages", "#tours"],
  ["Offers", "#offers"],
  ["Blog", "#blog"],
];

const InstagramIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.16-.42-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41 1.27-.06 1.65-.07 4.85-.07M12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.79.3-1.46.72-2.12 1.38A5.87 5.87 0 0 0 .63 4.14c-.3.76-.5 1.64-.56 2.91C.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.3.79.72 1.46 1.38 2.12a5.87 5.87 0 0 0 2.12 1.38c.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56a5.87 5.87 0 0 0 2.12-1.38 5.87 5.87 0 0 0 1.38-2.12c.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.87 5.87 0 0 0-1.38-2.12A5.87 5.87 0 0 0 19.86.63c-.76-.3-1.64-.5-2.91-.56C15.67.01 15.26 0 12 0Z" />
    <path d="M12 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32ZM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z" />
    <circle cx="18.41" cy="5.59" r="1.44" />
  </svg>
);

const FacebookIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.09 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.25h3.33l-.53 3.49h-2.8V24C19.61 23.09 24 18.1 24 12.07Z" />
  </svg>
);

const SOCIALS = [
  { name: "Instagram", href: SOCIAL.instagram, Icon: InstagramIcon },
  { name: "Facebook", href: SOCIAL.facebook, Icon: FacebookIcon },
].filter((s) => s.href);

export default function Footer() {
  return (
    <footer id="footer" className="bg-navy text-white/70">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 sm:grid-cols-2 lg:grid-cols-4 lg:px-8">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2">
            <span className="grid h-10 w-10 place-items-center rounded-full bg-accent font-heading font-bold text-white">
              J
            </span>
            <span className="font-heading text-lg font-bold text-white">
              JSR<span className="text-accent">Travels</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed">
            Vijay Nagar,Indore
          </p>
          <a
            href={`tel:${CONTACT.persons[0].tel}`}
            className="mt-4 inline-flex items-center gap-2 font-heading text-lg font-semibold text-white transition-colors hover:text-accent"
          >
            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-accent text-white">
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                className="h-4 w-4"
                aria-hidden="true"
              >
                <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.03-.24 11.4 11.4 0 0 0 3.56.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.56a1 1 0 0 1-.25 1.03l-2.2 2.2Z" />
              </svg>
            </span>
            {CONTACT.persons[0].phone}
          </a>

          <div className="mt-5 flex gap-3">
            {SOCIALS.map(({ name, href, Icon }) => (
              <a
                key={name}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`JSR Travels on ${name}`}
                title={name}
                className="grid h-10 w-10 place-items-center rounded-full bg-white/10 text-white transition-colors hover:bg-accent"
              >
                <Icon className="h-5 w-5" />
              </a>
            ))}
          </div>
        </div>

        {/* Destinations */}
        <div>
          <h4 className="mb-4 font-heading text-base font-semibold text-white">
            Destinations
          </h4>
          <ul className="space-y-3 text-sm">
            {DESTINATIONS.map((d) => (
              <li key={d}>
                <a
                  href="#offers"
                  className="transition-colors hover:text-accent"
                >
                  {d}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Useful links */}
        <div>
          <h4 className="mb-4 font-heading text-base font-semibold text-white">
            Useful Links
          </h4>
          <ul className="space-y-3 text-sm">
            {LINKS.map(([label, href]) => (
              <li key={label}>
                <a href={href} className="transition-colors hover:text-accent">
                  {label}
                </a>
              </li>
            ))}
            <li>
              <a
                href={`tel:${CONTACT.persons[0].tel}`}
                className="transition-colors hover:text-accent"
              >
                {CONTACT.persons[0].phone}
              </a>
            </li>
          </ul>
        </div>

        {/* Newsletter */}
        <div>
          <h4 className="mb-4 font-heading text-base font-semibold text-white">
            Newsletter
          </h4>
          <p className="text-sm">
            Get exclusive travel deals and tips in your inbox.
          </p>
          <form
            onSubmit={(e) => e.preventDefault()}
            className="mt-4 flex overflow-hidden rounded-full bg-white/10 p-1"
          >
            <input
              type="email"
              required
              placeholder="Your email"
              className="w-full bg-transparent px-4 py-2 text-sm text-white placeholder-white/40 outline-none"
            />
            <button className="shrink-0 rounded-full bg-accent px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-accent-dark">
              Join
            </button>
          </form>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-5 text-sm sm:flex-row lg:px-8">
          <span>
            © {new Date().getFullYear()} JSR Travels. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}
